import { render, staticRenderFns } from "./PermissionsManager.vue?vue&type=template&id=ac89edde"
import script from "./PermissionsManager.vue?vue&type=script&lang=js"
export * from "./PermissionsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports